import { Link } from 'react-router-dom';
import { type UiLinkComponent, type UiLinkProps } from '@icebreaker/ui';

/**
 * YÖNLENDİRİCİ SINIRI — kitin `UiLinkComponent` yuvasına `react-router` takılır.
 *
 * Kit hiçbir çerçeveyi import ETMEZ (`packages/ui/src/framework-freedom.guard.spec.ts`
 * bunu makineyle kilitler): bağlantı çizen bileşen bağlantı BİLEŞENİNİ
 * proptan alır. Next tarafı `next/link` verir, panel bu dosyayı verir.
 * Bileşen değil ENJEKSİYONDUR — burada görsel karar yoktur.
 *
 * DIŞ BAĞLANTI İSTİSNASI: `href` mutlak bir adresse (public site, e-posta)
 * yönlendirici onu ele alamaz; düz `<a>` çizilir.
 */
export const RouterLink: UiLinkComponent = ({ href, children, ...rest }: UiLinkProps) => {
  if (/^[a-z]+:|^\/\//i.test(href)) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
};
